var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-link",
    {
      ref: "export",
      attrs: { type: _vm.type, disabled: _vm.disabled },
      on: { click: _vm.clickExport }
    },
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }